import { QuicksilverConfig } from "quick-score";
import { QuickScoreAdapter } from "./QuickScoreAdapter";
export class QuicksilverAdapter extends QuickScoreAdapter {
    constructor() {
        super(...arguments);
        this.name = "Quicksilver (original algorithm)";
    }
    get defaultOptions() {
        return {
            config: QuicksilverConfig
        };
    }
}
